/* eslint-disable new-cap */
import React, { useState, useEffect, useRef } from "react"
import _isEmpty from "lodash/isEmpty"
import _get from "lodash/get"
import { NumericFormat } from "react-number-format"
import { useDispatch, useSelector } from "react-redux"
import useWindowResize from "@/hooks/useWindowResize"
import { onImageError } from "@/utils/index"

import {
  getReqItemLwData,
  fetchPdpRequiredItems,
} from "@/store/features/pdpSlice"
import { useTranslation } from "next-i18next"
import Modal from "@/components/core/Modal/Modal"
import Button from "@/components/core/Button/Button"
import ListRequiredItem from "@/components/MyFavorites/v1/MyList/ListRequiredItemModal/ListRequiredItem"
import { getTranslations } from "@/components/MyFavorites/v1/MyList/localization"
import styles from "@/components/MyFavorites/v1/MyList/ListRequiredItemModal/index.module.scss"
import { getColorDataObject } from "@/components/ProductDetail/v3/productDetailsHelper"
import { getFormatedImages } from "@/components/ProductDetail/v3/ProductDetailView/utils"
import MissingImage from "@/public/images/image-missing.png"
import CONSTANTS, { SWATCH_NA } from "@/constants/index"
import { selectGenericState } from "@/store/features/genericSlice"
import { isCanadaSite } from "@/utils/helper"
import { getStock } from "@/utils/cart"
import PropTypes from "prop-types"

const ListRequiredItemModal = props => {
  const {
    installReq,
    discountPercent,
    isType,
    onModalClose,
    showModal,
    listItemsPrice,
    productRequiredAccessories,
    productDetailData,
    handleAddToCartWithInstallItems,
    isSkuDiscontinued,
    productBackOrdered,
  } = props

  const { t } = useTranslation("common")
  const staticTexts = getTranslations(t)
  const {
    masterSKU_s: sku = "",
    ProductDescriptionProductShort_s: desc = "",
    productName_s: name = "",
  } = productDetailData

  const price = listItemsPrice[sku] ?? 0
  const discountedPrice = listItemsPrice[`${sku}-discount`] ?? 0
  const customerFacingSKU = listItemsPrice[`${sku}-customerFacingSKU`] ?? ""
  const dispatch = useDispatch()
  const { authorData = {}, globalConfig: config = {} } =
    useSelector(selectGenericState)

  const [addItems, setAddItems] = useState([])
  const [enableInclude, setEnableInclude] = useState(false)
  const [mainProductOutOfStock, setMainProductOutOfStock] = useState(false)
  const [imageUrl, setImageUrl] = useState("")
  const [colorsData, setColorsData] = useState([])
  const [installRequiredItemsData, setInstallRequiredItemsData] = useState([])
  const [reqItemLwData, setReqItemLwData] = useState([])
  const modalWindow = useRef(null)
  const itemScroll = useRef(null)
  const [width] = useWindowResize()

  const isKohlerCanada = isCanadaSite(config?.general?.siteName)
  const currencySign = isKohlerCanada ? "CAD $" : "$"
  const {
    general = {},
    internationalization: { currencyCode = "", locale = "" } = {},
  } = config || {}
  const { siteName: brandName = "", lwAppName = "" } = general

  window.addEventListener("click", function (e) {
    if (e?.target?.contains(modalWindow?.current)) {
      onModalClose()
    }
  })
  useEffect(() => {
    getStock(productDetailData["masterSKU_s"], true)
      .then(({ stock = 0 }) => {
        setMainProductOutOfStock(stock <= 0)
      })
      .catch(() => {})
  }, [productDetailData["masterSKU_s"]])

  useEffect(() => {
    if (!_isEmpty(config)) {
      const { general: { swatchUrl = "" } = {} } = config
      let variants = []
      let colors = []
      const availableColors = []
      const disContinuedColors = []
      if (productDetailData["variantList.sku_s"]) {
        variants = [productDetailData["variantList.sku_s"]]
      } else if (productDetailData["variantList.sku_ss"]) {
        variants = productDetailData["variantList.sku_ss"]
      }
      // get list of variant colors
      const colorDetailsResponseOne =
        productDetailData["Color.SKU.Details_ss"] ?? []
      const colorDetailsResponseTwo =
        productDetailData["Color.SKU.Details_s"] ?? []
      if (colorDetailsResponseOne) {
        colors = colorDetailsResponseOne.map(color => {
          return getColorDataObject(color)
        })
      } else if (colorDetailsResponseTwo) {
        colors = [getColorDataObject(colorDetailsResponseTwo)]
      } else if (productDetailData["SKU.Details_ss"]) {
        colors = productDetailData["SKU.Details_ss"].map(color => {
          const d = color.split("|")
          return {
            name: staticTexts.notApplicable,
            swatch: SWATCH_NA,
            sku: d[0],
            isStock: d[1],
            discontinued: !(d[2] === "false" || Date.parse(d[2]) > Date.now()),
            customerSku: d[3],
          }
        })
      }

      colors.forEach(color => {
        const colorObj = {
          id: color.sku,
          name: "product-color",
          value: color.sku,
          label: color.name,
          notApplicable: color.swatch.toLowerCase() === SWATCH_NA.toLowerCase(),
          colorUrl: CONSTANTS.COLOR_FILE_URL + color.swatch,
          checked: color.sku === productDetailData["masterSKU_s"],
          discontinuedColor: color.discontinued,
          slug: color.slug,
        }
        color.discontinued
          ? disContinuedColors.push(colorObj)
          : availableColors.push(colorObj)
      })
      const isDisContinuedColor = colors.find(
        color => color.sku === productDetailData["masterSKU_s"]
      )?.discontinued
      const colorsData = isDisContinuedColor
        ? disContinuedColors
        : availableColors
      setColorsData(colorsData)
      const variantImages = productDetailData["productImages.labelWithUrl_s"]
        ? [productDetailData["productImages.labelWithUrl_s"]]
        : productDetailData["productImages.labelWithUrl_ss"]

      let variantImageLabels = []
      let variantImageURLs = []
      if (variantImages?.length) {
        const selVarImageUrls = []
        const selVarImageLabels = []
        variantImages.map(img => {
          const imgDetail = img.split("|")
          if (productDetailData["masterSKU_s"] === imgDetail[0]) {
            selVarImageLabels.push(imgDetail[4] ?? "")
            selVarImageUrls.push(
              imgDetail[imgDetail.length - 1]
                ? imgDetail[imgDetail.length - 1]
                : MissingImage?.src
            )
          } else if (!variants.find(v => v === imgDetail[0])) {
            variantImageLabels.push(imgDetail[4] ?? "")
            variantImageURLs.push(
              imgDetail[imgDetail.length - 1]
                ? imgDetail[imgDetail.length - 1]
                : MissingImage?.src
            )
          }
        })
        variantImageLabels = [...selVarImageLabels, ...variantImageLabels]
        variantImageURLs = [...selVarImageUrls, ...variantImageURLs]
        if (variantImageURLs.length < 1) {
          variantImageLabels.push(productDetailData["masterSKU_s"])
          variantImageURLs.push(MissingImage?.src)
        }
      } else {
        variantImageLabels.push(productDetailData["masterSKU_s"])
        variantImageURLs.push(MissingImage?.src)
      }

      const imagesData = getFormatedImages({
        variantImageLabels,
        variantImageURLs,
        authorData,
      })

      const imageUrl = swatchUrl + imagesData[0]?.assetId
      setImageUrl(imageUrl)
      getRequiredProductsData()
    }
  }, [])

  useEffect(() => {
    if (addItems.length !== 0) {
      setEnableInclude(true)
    } else {
      setEnableInclude(false)
    }
  }, [addItems])

  const getRequiredProductsData = () => {
    if (productRequiredAccessories.length) {
      let query = ""
      let lwQuery = ""
      productRequiredAccessories.forEach((item, i) => {
        query =
          query +
          `"${item?.id}"${
            i !== productRequiredAccessories.length - 1 ? "," : ""
          }`
        lwQuery += `"${item?.id}" `
      })
      dispatch(fetchPdpRequiredItems(query))
        .unwrap()
        .then(response => {
          setInstallRequiredItemsData(response)
          dispatch(getReqItemLwData({ lwQuery, brandName, lwAppName }))
            .unwrap()
            .then(lwData => {
              setReqItemLwData(lwData ?? [])
            })
        })
        .catch(err => {
          console.error("Fetching data failed", err)
        })
    }
  }

  const updateItems = (checked, item) => {
    let installRequireItems = addItems
    if (checked) {
      installRequireItems = installRequireItems.filter(
        requiredProduct =>
          requiredProduct.masterVariantSku !== item.masterVariantSku
      )
      installRequireItems.push(item)
    } else {
      installRequireItems = installRequireItems.filter(
        requiredProduct => requiredProduct.skuid !== item.skuid
      )
    }
    setAddItems([...installRequireItems])
  }

  const includeOnClick = () => {
    handleAddToCartWithInstallItems(addItems)
  }

  const addToCartButtonStatus = enableInclude => {
    const mainCheck = isSkuDiscontinued || !enableInclude
    const backOrderCheck = mainProductOutOfStock && !productBackOrdered
    return !!(mainCheck || backOrderCheck)
  }

  useEffect(() => {
    if (
      width > 991 &&
      showModal &&
      itemScroll.current &&
      installRequiredItemsData?.length > 0
    ) {
      if (window.OverlayScrollbars) {
        window.OverlayScrollbars(itemScroll?.current, {
          className: "os-theme-dark",
          resize: "none",
          sizeAutoCapable: true,
          clipAlways: true,
          normalizeRTL: true,
          paddingAbsolute: false,
          autoUpdate: null,
          autoUpdateInterval: 33,
          nativeScrollbarsOverlaid: {
            showNativeScrollbars: false,
            initialize: true,
          },
          overflow: {
            x: "hidden",
          },
          scrollbars: {
            visibility: "auto",
            autoHide: "never",
            autoHideDelay: 800,
            dragScrolling: true,
            clickScrolling: true,
            touchSupport: true,
            snapHandle: true,
          },
        })
      }
    }
  }, [showModal, itemScroll?.current, installRequiredItemsData, width])

  const handleAddToCart = event => {
    includeOnClick()
  }

  return (
    <div className={styles.listRequiredItemModalWrapper}>
      <div className="product-detail-page__install-items-modal">
        <Modal showModal={showModal} onModalClose={onModalClose}>
          <div className="required-item" ref={modalWindow}>
            <div className="required-item__container">
              <div className="required-item__left-section">
                <div className="product-title">{staticTexts.title}</div>
                <div className="item-details">
                  <div className="item-details__image">
                    <div className="product-image">
                      <img
                        className="product-image-container"
                        src={imageUrl}
                        alt={name}
                        onError={e => onImageError(e, imageUrl)}
                      />
                    </div>
                  </div>

                  <div className="item-details__info">
                    <div className="product-family-name">{name}</div>
                    <div className="product-description">{desc}</div>
                    <div className="sku-id">{customerFacingSKU || sku}</div>
                    {colorsData.filter(c => !c.notApplicable).length > 0 && (
                      <div className="color-finish">
                        <span>{"Color/Finish"}</span> :{" "}
                        <span>
                          {_get(
                            colorsData.find(item => item.id === sku),
                            "label",
                            ""
                          )}
                        </span>
                      </div>
                    )}
                    {price > 0 && (
                      <div className="price">
                        <span className="price-amount">
                          <NumericFormat
                            value={
                              discountedPrice > 0 ? discountedPrice : price
                            }
                            displayType="text"
                            thousandSeparator={true}
                            prefix={currencySign}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </span>
                      </div>
                    )}
                    {discountedPrice > 0 && (
                      <div className="required-item__display-discount --mobile">
                        {discountPercent > 0 && (
                          <span className="required-item__percent-off">
                            {isType === "absolute"
                              ? currencySign + discountPercent
                              : discountPercent + "%"}{" "}
                            {staticTexts.percentOff}
                          </span>
                        )}
                        <span className="required-item__discount-price --mobile">
                          <NumericFormat
                            value={price}
                            displayType="text"
                            thousandSeparator={true}
                            prefix={currencySign}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="required-item__right-section">
                <h2 className="required-product-title">
                  {isKohlerCanada
                    ? staticTexts.cadRequiredProductTitle
                    : staticTexts.requiredProductTitle}
                </h2>

                <div className="required-product-description">
                  {isKohlerCanada
                    ? staticTexts.cadRequiredProductDescription
                    : staticTexts.requiredProductDescription}
                </div>

                <div className="required-product-header">
                  <div>{staticTexts.productText}</div>
                  {isKohlerCanada ? null : (
                    <div>{staticTexts.includeTextCTA}</div>
                  )}
                </div>

                <div ref={itemScroll} className="product-line-items">
                  {installRequiredItemsData.length > 0 &&
                    installRequiredItemsData.map((product, i) => {
                      const lwProdData =
                        reqItemLwData?.find(i => product.id === i.ctId_s) ?? {}
                      return (
                        <ListRequiredItem
                          staticTexts={staticTexts}
                          key={i}
                          addItemsData={addItems}
                          item={product}
                          updateItems={(checked, item) =>
                            updateItems(checked, item)
                          }
                          currencyCode={currencyCode}
                          currencySign={currencySign}
                          locale={locale}
                          colorId={i}
                          backorder={
                            lwProdData["RegionOnBackOrder_s"] === "Yes"
                          }
                          productInfo={productDetailData}
                          isKohlerCanada={isKohlerCanada}
                          {...props}
                        />
                      )
                    })}
                </div>

                {isKohlerCanada ? null : (
                  <div className="include-button">
                    <Button
                      useDefaultClass={true}
                      role="button"
                      label={
                        installReq?.length
                          ? staticTexts.updateText
                          : staticTexts.includeTextCTA
                      }
                      size="medium"
                      type="primary"
                      onClick={handleAddToCart}
                      disabled={addToCartButtonStatus(enableInclude)}
                    ></Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  )
}

ListRequiredItemModal.propTypes = {
  installReq: PropTypes.array,
  discountPercent: PropTypes.number,
  isType: PropTypes.string,
  onModalClose: PropTypes.func,
  showModal: PropTypes.bool,
  listItemsPrice: PropTypes.object,
  productRequiredAccessories: PropTypes.array,
  productDetailData: PropTypes.object,
  handleAddToCartWithInstallItems: PropTypes.func,
  isSkuDiscontinued: PropTypes.bool,
  productBackOrdered: PropTypes.bool,
}

export default ListRequiredItemModal
